import { createStore, compose } from 'redux';

// import { composeWithDevTools } from 'redux-devtools-extension';

import { persistStore } from 'redux-persist';

import rootReducer from './reducers';

// const initialState: any = {};

// const composeEnhancers =
//   process.env.NODE_ENV === 'production' ? compose : composeWithDevTools({ trace: true, traceLimit: 25 });

const composeEnhancers =
  (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(rootReducer, composeEnhancers());

export const persistor = persistStore(store);

export default store;
